import React, { useState, useEffect } from 'react';
import {
    TextField,
    Button,
    Typography,
    Container,
    Box,
    Paper,
    Toolbar,
    IconButton,
    AppBar,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
} from '@mui/material';
import api from './AxiosConfig';
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import GroupIcon from '@mui/icons-material/Group';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import HistoryIcon from '@mui/icons-material/History';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import OrderHistoryPanel from "./OrderHistoryPanel";
import ManageMenu from "./ManageMenu";
import ManageWaiters from "./ManageWaiters";
import ActualOrderPanel from "./ActualOrderPanel";
import Loading from "../Loading"; // nowy import

const RestaurantLoginPanel = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [token, setToken] = useState(localStorage.getItem("tokenRestaurant") || null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [showManageMenu, setShowManageMenu] = useState(false);
    const [showManageWaiters, setShowManageWaiters] = useState(false);
    const [showOrderHistory, setShowOrderHistory] = useState(false);
    const [showActualOrders, setShowActualOrders] = useState(false); // nowy stan
    const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;

    const [openQRCodeDialog, setOpenQRCodeDialog] = useState(false);
    const [tableNumber, setTableNumber] = useState('');
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await api.post(`${baseUrl}/api/auth/login`, {
                username,
                password,
                role: 'ROLE_RESTAURANT',
            });
            setToken(response.data.jwt);
            setUsername('');
            setPassword('');
            localStorage.setItem('tokenRestaurant', response.data.jwt);
            setIsLoggedIn(true);
        } catch (error) {
            alert('Nieprawidłowe dane logowania');
        } finally {
            setLoading(false)
        }
    };

    const handleDownloadQRCode = () => {
        if (qrCodeUrl) {
            const link = document.createElement('a');
            link.href = qrCodeUrl;
            link.download = `qr_stolik_${tableNumber}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const handleShowOrderHistory = () => {
        setShowOrderHistory(true);
        setShowManageWaiters(false);
        setShowManageMenu(false);
        setShowActualOrders(false);
    };

    const handleBackToMenu = () => {
        setShowOrderHistory(false);
        setShowManageWaiters(false);
        setShowManageMenu(false);
        setShowActualOrders(false);
    };

    const handleLogout = () => {
        setIsLoggedIn(false);
        setToken(null);
        localStorage.removeItem('tokenRestaurant');
    };

    useEffect(() => {
        const storedToken = localStorage.getItem("tokenRestaurant");
        if (storedToken) {
            setIsLoggedIn(true);
            setToken(storedToken);
        } else {
            handleLogout();
        }
    }, []);

    const handleGenerateQRCode = async () => {
        setLoading(true);
        try {
            const response = await api.get(`${baseUrl}/api/restaurant/generateCode`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { tableNumber },
                responseType: 'blob'
            });
            const imageUrl = URL.createObjectURL(response.data);
            setQrCodeUrl(imageUrl);
        } catch (error) {
            console.error('Błąd podczas generowania kodu QR:', error);
        } finally {
            setLoading(false)
        }
    };

    if (isLoggedIn) {
        return (
            <Container>
                <Loading open={loading} />
                <AppBar position="fixed">
                    <Toolbar sx={{ justifyContent: 'space-between' }}>
                        <Typography variant="h6">Panel Restauracji</Typography>
                        <Typography variant="h6" edge="end" color="inherit" onClick={handleLogout} sx={{ cursor: 'pointer' }}>
                            Wyloguj się
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Box mt={12}>
                    {(!showManageMenu && !showManageWaiters && !showOrderHistory && !showActualOrders) ? (
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Paper onClick={() => setShowManageWaiters(true)} sx={{ padding: 2, textAlign: 'center', cursor: 'pointer' }} elevation={3}>
                                    <GroupIcon sx={{ fontSize: 50 }} />
                                    <Typography variant="h6">Zarządzaj kelnerami</Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Paper onClick={() => setShowManageMenu(true)} sx={{ padding: 2, textAlign: 'center', cursor: 'pointer' }} elevation={3}>
                                    <RestaurantMenuIcon sx={{ fontSize: 50 }} />
                                    <Typography variant="h6">Zarządzaj menu</Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Paper onClick={handleShowOrderHistory} sx={{ padding: 2, textAlign: 'center', cursor: 'pointer' }} elevation={3}>
                                    <HistoryIcon sx={{ fontSize: 50 }} />
                                    <Typography variant="h6">Historia zamówień</Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Paper onClick={() => setShowActualOrders(true)} sx={{ padding: 2, textAlign: 'center', cursor: 'pointer' }} elevation={3}>
                                    <ReceiptLongIcon sx={{ fontSize: 50 }} />
                                    <Typography variant="h6">Aktualne zamówienia</Typography>
                                </Paper>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper
                                    onClick={() => {
                                        setOpenQRCodeDialog(true);
                                        setTableNumber('');
                                        setQrCodeUrl('');
                                    }}
                                    sx={{ padding: 2, textAlign: 'center', cursor: 'pointer' }}
                                    elevation={3}
                                >
                                    <QrCode2Icon sx={{ fontSize: 50 }} />
                                    <Typography variant="h6">Generuj kod QR</Typography>
                                </Paper>
                            </Grid>
                        </Grid>
                    ) : showManageMenu ? (
                        <ManageMenu token={token} baseUrl={baseUrl} onBack={() => setShowManageMenu(false)} />
                    ) : showManageWaiters ? (
                        <ManageWaiters token={token} baseUrl={baseUrl} onBack={() => setShowManageWaiters(false)} />
                    ) : showOrderHistory ? (
                        <OrderHistoryPanel token={token} baseUrl={baseUrl} onBack={handleBackToMenu} />
                    ) : showActualOrders ? (
                        <ActualOrderPanel token={token} baseUrl={baseUrl} onBack={() => setShowActualOrders(false)} />
                    ) : null}
                </Box>
                <Dialog open={openQRCodeDialog} onClose={() => setOpenQRCodeDialog(false)}>
                    <DialogTitle>Generuj kod QR</DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Numer stolika"
                            value={tableNumber}
                            type="number"
                            onChange={(e) => setTableNumber(e.target.value)}
                            fullWidth
                            sx={{ marginTop: 2 }}
                        />
                        {qrCodeUrl && (
                            <Box sx={{ mt: 2, textAlign: 'center' }}>
                                <img src={qrCodeUrl} alt="Kod QR" style={{ width: 300, height: 300 }} />
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenQRCodeDialog(false)}>Anuluj</Button>
                        <Button onClick={handleGenerateQRCode}>Generuj</Button>
                        {qrCodeUrl && (
                            <Button onClick={handleDownloadQRCode}>Pobierz</Button>
                        )}
                    </DialogActions>
                </Dialog>
            </Container>
        );
    }

    return (
        <Container maxWidth="xs">
            <Paper elevation={3} sx={{ padding: 3, marginTop: 5 }}>
                <Typography variant="h4" align="center" sx={{ marginBottom: 2 }}>
                    Logowanie
                </Typography>
                <form onSubmit={handleLogin}>
                    <TextField
                        label="Nazwa użytkownika"
                        variant="outlined"
                        fullWidth
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        sx={{ marginBottom: 2 }}
                    />
                    <TextField
                        label="Hasło"
                        type="password"
                        variant="outlined"
                        fullWidth
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        sx={{ marginBottom: 2 }}
                    />
                    <Button type="submit" variant="contained" color="primary" fullWidth>
                        Zaloguj się
                    </Button>
                </form>
            </Paper>
        </Container>
    );
};

export default RestaurantLoginPanel;